/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a held virtual token participates in entry. REQUIRED = the token is the only entry method (opt-in comp, no fuel fee — the token is burned on join). WAIVES_FEE = holding an accepted token waives the fuel entry fee; otherwise the player pays fuel normally.
 * @export
 */
export const TokenEntryMode = {
    REQUIRED: 'REQUIRED',
    WAIVES_FEE: 'WAIVES_FEE'
} as const;
export type TokenEntryMode = typeof TokenEntryMode[keyof typeof TokenEntryMode];


export function instanceOfTokenEntryMode(value: any): boolean {
    for (const key in TokenEntryMode) {
        if (Object.prototype.hasOwnProperty.call(TokenEntryMode, key)) {
            if (TokenEntryMode[key as keyof typeof TokenEntryMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TokenEntryModeFromJSON(json: any): TokenEntryMode {
    return TokenEntryModeFromJSONTyped(json, false);
}

export function TokenEntryModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenEntryMode {
    return json as TokenEntryMode;
}

export function TokenEntryModeToJSON(value?: TokenEntryMode | null): any {
    return value as any;
}

export function TokenEntryModeToJSONTyped(value: any, ignoreDiscriminator: boolean): TokenEntryMode {
    return value as TokenEntryMode;
}

